<template>
    <button
            class="InterButton"
            :class="[
            { 'block': block },
              styleBtn,
            { 'disabled': !enabled },
            size
            ]"
            :disabled="!enabled"
            v-on:click.prevent="onClick">
        {{currentLabel}}
    </button>
</template>

<script>
    export default {
        name: "InterButton",
        data() {
            return {
                enableAction: false,
                iconConfirm: 'flaticon-exclamation-mark-inside-a-circle',
                currentLabel: ''
            }
        },
        props: {
            block: {
                type: Boolean,
                default: false
            },
            enabled: {
                type: Boolean,
                default: true
            },
            size :{
                type: String,
                default: ''
            },
            styleBtn: {
                type: String,
                default: 'primaryButton'
            },
            confirm: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: 'Salva'
            }
        },
        mounted() {
            this.currentLabel = this.label;
        },
        methods: {
            onClick: function () {
                if(this.confirm) {
                    if(this.enableAction) {
                        this.enableAction = false;
                        this.currentLabel = this.label;
                        this.$emit('onClick');
                    } else {
                        this.currentLabel = 'Procedo ?';
                        this.enableAction = true;
                    }
                } else {
                    this.$emit('onClick');
                }

            }
        }
    }
</script>

<style lang="scss" scoped>

    .block {
        width: 100%;
    }

    .disabled {
        opacity: 0.6 !important;
    }

</style>
